import { render, staticRenderFns } from "./recipe_details.vue?vue&type=template&id=3f9e3332&scoped=true&lang=html&"
import script from "./recipe_details.vue?vue&type=script&lang=js&"
export * from "./recipe_details.vue?vue&type=script&lang=js&"
import style0 from "./recipe_details.vue?vue&type=style&index=0&id=3f9e3332&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9e3332",
  null
  
)

export default component.exports